"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDoctorAttendingsWithAccountingsListApiResponseSchema = exports.getDoctorAttendingWithAccountingsListItemApiEntitySchema = void 0;
const zod_1 = require("zod");
const api_1 = require("../global/api");
const paginate_list_api_response_schema_1 = require("../global/paginate-list-api-response.schema");
const office_1 = require("../offices/office");
exports.getDoctorAttendingWithAccountingsListItemApiEntitySchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    type: (0, api_1.apiEntityTypeSchema)('doctor-attendings'),
    attributes: zod_1.z.object({
        firstname: zod_1.z.string(),
        lastname: zod_1.z.string(),
        createdAt: zod_1.z.coerce.date(),
    }),
    relationships: zod_1.z.object({
        office: (0, api_1.apiEntityRelationshipSchema)('offices'),
    }),
});
exports.getDoctorAttendingsWithAccountingsListApiResponseSchema = (0, paginate_list_api_response_schema_1.paginteListApiResponseSchema)(exports.getDoctorAttendingWithAccountingsListItemApiEntitySchema).merge(zod_1.z.object({
    included: zod_1.z.array(office_1.simpleOfficeApiSchema).optional().default([]),
}));
